import { RequirementParams, RequirementSubjectType } from '@/backend/access/requirement/types';

export class Requirement {
  id: string;
  createdAt?: Date | string;
  updatedAt?: Date | string;
  name: string;
  title: string;
  description: string;
  propelOrgId: string;
  type: string;
  subjectId: string;
  subjectType: RequirementSubjectType;
  sourceId?: string | null;
  identifier?: string | null;
  applicable: boolean;
  comment?: string | null;
  assignedUserId: string | null;
  assignedSupplierUserId: string | null;

  constructor(params: RequirementParams) {
    this.id = params.id;
    this.createdAt = params.createdAt;
    this.updatedAt = params.updatedAt;
    this.name = params.name;
    this.title = params.name;
    this.description = params.description;
    this.propelOrgId = params.propelOrgId;
    this.type = params.type;
    this.subjectId = params.subjectId;
    this.subjectType = params.subjectType;
    this.sourceId = params.sourceId;
    this.identifier = params.identifier;
    this.applicable = params.applicable;
    this.comment = params.comment;
    this.assignedUserId = params.assignedUserId;
    this.assignedSupplierUserId = params.assignedSupplierUserId;
  }

  toData() {
    return {
      id: this.id,
      createdAt: this.createdAt,
      updatedAt: this.updatedAt,
      name: this.name,
      description: this.description,
      propelOrgId: this.propelOrgId,
      type: this.type,
      subjectId: this.subjectId,
      subjectType: this.subjectType,
      sourceId: this.sourceId,
      identifier: this.identifier,
      applicable: this.applicable,
      comment: this.comment,
      assignedUserId: this.assignedUserId,
      assignedSupplierUserId: this.assignedSupplierUserId,
    };
  }
}
